import {FILE_STATUS_MESSAGES, FileStatus, ApolloCatalogData} from "./model";

const getFileStatusTranslation = (fileStatus: FileStatus, intl) => {
  if (fileStatus === FileStatus.SUCCESS) {
    return intl.formatMessage(FILE_STATUS_MESSAGES.success);
  } else if (fileStatus === FileStatus.SKIPPED) {
    return intl.formatMessage(FILE_STATUS_MESSAGES.skipped);
  } else if (fileStatus === FileStatus.FAILED) {
    return intl.formatMessage(FILE_STATUS_MESSAGES.failed);
  }

  return fileStatus;
};

const getSelectedPath = (folders: ApolloCatalogData[], selectedFolderId: string) => {
  if (!selectedFolderId) {
    return [];
  }
  const path: ApolloCatalogData[] = [];
  let folder = folders.filter(f => f.id === selectedFolderId)[0];
  if (!folder) {
    return path;
  }
  do {
    if (folder) {
      path.push(folder);
    }
    if (!folder || folder.parent === null) {
      break;
    }
    folder = folders.filter(f => f.id === folder.parent.id)[0];
  } while (true);
  return path.reverse();
};

export {
  getFileStatusTranslation,
  getSelectedPath,
};